import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BreadcrumbComponent } from '../../Common/Components/breadcrumb/breadcrumb.component';
import { SpinnerComponent } from '../../Common/Components/spinner/spinner.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { DataGridComponent } from '../../Common/Components/data-grid/data-grid.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { ApiService } from '../../Services/api.service';
import { AddEditPriceDetailComponent } from './add-edit-price-detail/add-edit-price-detail.component';
import { NzInputModule } from 'ng-zorro-antd/input';
import { ConfirmPopupComponent } from '../../Common/Components/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-price-display-setup',
  standalone: true,
  imports: [SpinnerComponent, NzButtonModule, NzInputModule, NzDrawerModule, RouterModule, CommonModule, FormsModule, DataGridComponent, NzIconModule, NzSelectModule, AddEditPriceDetailComponent,
    ConfirmPopupComponent
  ],
  templateUrl: './price-display-setup.component.html',
  styleUrl: './price-display-setup.component.scss'
})
export class PriceDisplaySetupComponent {
  constructor(private apiService: ApiService) {

  }
  isLoading: boolean = false;
  linkDrawer: boolean = false;
  showModal: boolean = false;
  selectedAREDP: any = "";
  invalidSearch: boolean = false;
  priceDisplayData: any = [];
  orgPriceDisplayData: any = [];
  selectedPriceDisplay: any = [];
  priceDisplayColumns = [
    {
      field: 'uniqueId',
      header: '',
      type: "checkbox"
    },
    {
      field: 'edpNo',
      header: 'EDP/AR #',
      compare: (a: any, b: any) => (a.edpNo ?? "").localeCompare((b.edpNo ?? ""))
    },
    {
      field: 'lotId',
      header: 'Lot Id',
      compare: (a: any, b: any) => (a.lotId ?? "").localeCompare((b.lotId ?? ""))
    },
    {
      field: 'samePriceForAllSkus',
      header: 'Same Price for all Sizes',
      type: 'toggle',
    },
    {
      field: '',
      header: 'Action',
      icons: ['delete'],
      type: 'icon',
      showIcons: true
    }];
  toggledRows: any = [];
  edpArList: any = [];
  @ViewChild(DataGridComponent) private dataGridComponent!: DataGridComponent;
  searchText: string = '';
  errorMessage: string = '';


  ngOnInit(): void {

  }

  searchPriceDisplayList() {
    this.invalidSearch = false;

    const input = this.selectedAREDP ? this.selectedAREDP.toString().trim() : "";
    const len = input.length;

    if (!input) {
      this.invalidSearch = true;
      this.errorMessage = "* EDP/AR Selection is required.";
    } else if (len !== 5 && len !== 11) {
      this.invalidSearch = true;
      this.errorMessage = `Search Value should be 5 digits EDP or 11 digits AR no`;
    }

    if (this.invalidSearch) {
      return;
    }

    this.isLoading = true;
    this.invalidSearch = false;
    this.apiService.getPriceDisplayList(this.selectedAREDP).subscribe(res => {
      this.isLoading = false;
      this.priceDisplayData = res;
      this.priceDisplayData.map((node: any) => {
        Object.assign(node, { uniqueId: node.edpNo + "_" + node.lotId, oldGarmentType: node.garmentType })
      });
      this.orgPriceDisplayData = JSON.parse(JSON.stringify(this.priceDisplayData));
    }, err => {
      this.isLoading = false;
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  searchPriceDisplay(searchValue: string) {
    this.dataGridComponent.searchData(searchValue, 'edpNo');
  }

  reset() {
    this.priceDisplayData = JSON.parse(JSON.stringify(this.orgPriceDisplayData));
  }

  deleteRow(event: any) {
    const deleteObj = {
      "edpNo": event.edpNo,
      "lotId": [event.lotId],
      "updateType": "DELETE"
    };
    this.updatePriceList([deleteObj])
  }

  getEdpArNoList(event: string) {
    // 1. Force numeric only and max 11 characters
    let sanitized = event.replace(/\D/g, '').substring(0, 11);

    // 2. Logic to handle API calls
    const inputLength = sanitized.length;

    if (inputLength === 5 || inputLength === 11) {
      this.apiService.getEdpArNoLists(sanitized).subscribe(res => {
        if (res && res.data) {
          this.edpArList = res.data;

          // Ensure the current selection stays in the list so it doesn't disappear
          if (this.selectedAREDP && !this.edpArList.includes(this.selectedAREDP)) {
            this.edpArList = [this.selectedAREDP, ...this.edpArList];
          }
        }
      });
    } else if (inputLength === 0) {
      this.edpArList = [];
    }
  }
  onlyNumberKey(event: KeyboardEvent) {

    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  updatePriceList(data: any) {
    this.apiService.updatePriceDisplayList(data).subscribe(res => {
      this.apiService.createNotification('success', res?.message);
      if (this.selectedAREDP == '') {
        this.selectedPriceDisplay = [];
      }
      else {
        this.searchPriceDisplayList();
      }
      this.linkDrawer = false;
      this.showModal = false;

    }, err => {
      this.apiService.createNotification('error', err?.error?.message);
    })
  }

  selectedRows(data: any) {
    this.selectedPriceDisplay = Array.from(data).map(val => String(val));
    console.log(this.selectedPriceDisplay)
  }

  addRow(data: any) {
    this.linkDrawer = false;
    this.updatePriceList(data);
  }

  deleteSelected() {
    const deleteArr: any = [];

    const selectedIdSet = new Set(this.selectedPriceDisplay);

    const matchedRows = this.priceDisplayData.filter((row: any) => selectedIdSet.has(row.uniqueId));


    matchedRows.forEach((match: any) => {
      const alreadyAdded = deleteArr.some((entry: any) =>
        entry.edpNo === match.edpNo &&
        entry.lotId[0] === match.lotId &&
        entry.jobCode === match.jobCode
      );

      if (!alreadyAdded) {
        deleteArr.push({
          "edpNo": match.edpNo,
          "lotId": [match.lotId],
          "jobCode": match.jobCode,
          "updateType": "DELETE"
        });
      }
    });

    this.updatePriceList(deleteArr);
  }

  toggledRow(event: any) {
    if (this.toggledRows.length == 0 || !this.toggledRows.find((node: any) => node.uniqueId == event.uniqueId)) {
      const updateObj = {
        "edpNo": event.edpNo,
        "lotId": [event.lotId],
        "samePriceForAllSkus": event.samePriceForAllSkus ? 1 : 0,
        "updateType": "UPDATE"
      };
      this.toggledRows.push(updateObj);
    }
    else {
      const existEleIndex = this.toggledRows.findIndex((node: any) => node.jobCode === event.jobCode);
      this.toggledRows[existEleIndex]["samePriceForAllSkus"] = event.samePriceForAllSkus;
    }

  }
}
